import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 md:py-14 px-4 bg-[#d6e8fa] text-gray-900" data-id="element-117">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10" data-id="element-118">
        <div className="flex-shrink-0" data-id="element-119">
          <ShieldCheckIcon className="w-24 h-24 md:w-32 md:h-32 text-blue-600" data-id="element-120" />
        </div>
        <div className="text-center md:text-left" data-id="element-121">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold mb-4 text-blue-700" data-id="element-122">
            Garantía de 7 días
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed font-medium" data-id="element-123">
            "Si el material no cumple tus expectativas o sentís que no es para
            la edad de tu hijo/a, te devolvemos el 100% de tu dinero. Sin
            preguntas, sin vueltas. Tu compra está totalmente protegida."
          </p>
        </div>
      </div>
    </section>;
}